<template>
  <v-form @submit.prevent="$v.$invalid ? () => {} : submit()" ref="form">
    <v-snackbar v-model="snackbar" :color="snackbar_color" :timeout="2000" >
      <span>{{message}}</span>
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-card class="neu-glow">
        <v-card-title primary-title>
        <div class="text-h5">{{$t(page+'.Global Settings')}} <span class="subtitle-1">({{$t(page+'.with red background')}})</span></div>
    </v-card-title>
    <v-container grid-list-xl fluid>
    <v-row>
        <v-col md="4" cols="6">
          <v-text-field
            color="primary"
            :label="$t(page+'.COD Fees Rate')"
            name="CODFeesRate"
            v-model="form.CODFeesRate"
            prepend-inner-icon="fas fa-percent"
            @blur="$v.form.CODFeesRate.$touch()"
            required
            background-color="#ff000010"
            filled
            outlined
            dense
            reverse
            type="number"
            clearable
             clear-icon="far fa-trash-alt" 
             @click:clear="$parent.save(null,'CODFeesRate')"                          
            @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
            color="primary"
            :label="$t(page+'.Min. COD Fees')"
            name="minCODFees"
            v-model="Number(form.minCODFees).toFixed(2)"
            @blur="$v.form.minCODFees.$touch()"
            filled
            background-color="#ff000010"
            outlined
            dense
            reverse
            type="number"
            clearable
            clear-icon="far fa-trash-alt" 
             @click:clear="$parent.save(null,'minCODFees')"                          
            @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
            color="primary"
            :label="$t(page+'.Insurance Fees Rate')"
            name="insuranceFeesRate"
            v-model="form.insuranceFeesRate"
            prepend-inner-icon="fas fa-percent"
            @blur="$v.form.insuranceFeesRate.$touch()"
            filled
            background-color="#ff000010"              
            outlined
            dense
            reverse
            type="number"
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'insuranceFeesRate')"                          
            @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
            color="primary"
            :label="$t(page+'.Min Insurance Fees')"
            name="minInsuranceFees"
            v-model="Number(form.minInsuranceFees).toFixed(2)"
            @blur="$v.form.minInsuranceFees.$touch()"
            required
            background-color="#ff000010"
            filled
            outlined
            dense
            reverse
            type="number"
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'minInsuranceFees')"                          
            @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
            color="primary"
            :label="$t(page+'.Volume/Weight Ratio')"
            name="VWRatio"
            v-model="form.VWRatio"
            @blur="$v.form.VWRatio.$touch()"
            filled
            background-color="#ff000010"
            outlined
            dense
            reverse
            type="number"
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'VWRatio')"                          
            @input.native="$parent.save"
          ></v-text-field>
        </v-col>
        <v-col md="4" cols="6">
          <v-text-field
            color="primary"
            :label="$t(page+'.StockReleaseFees')"
            name="stockReleaseFees"
            v-model="form.stockReleaseFees"
            @blur="$v.form.stockReleaseFees.$touch()"
            filled
            background-color="#ff000010"
            outlined
            dense
            reverse
            type="number"
            clearable
            clear-icon="far fa-trash-alt" 
            @click:clear="$parent.save(null,'VWRatio')"                          
            @input.native="$parent.save"
          ></v-text-field>
        </v-col>
    </v-row>
    </v-container>
  </v-card>
  </v-form>
</template>
<script>
import { mapGetters } from "vuex";
import { required, maxLength } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";
import { availableCountries  } from "@/config/countries";
import _ from 'lodash'
const defaultForm = {
  company: "",
  address: "",
  postalcode: "",
  buildingnumber:"",
  city: "",
  stateorprovince: "",
  country: "",
  companyid: "",
  vatnumber: "",
  sdi: "",
  pec:"",
  iban:"",
  swift:""
};

export default {
  props: ['form'],
  mixins: [validationMixin],
  validations: {
    form: {
      company: { required },
      address: { required },
      buildingnumber: { required},
      postalcode: { required, maxLength: maxLength(8) },
      city: { required },
      stateorprovince: { required },
      country: { required },
      companyid: { required },
      vatnumber: { required },
      sdi: { required },
      pec: { required },
      iban: { required }
    },
  },
  validationMessages: {
    form: {
      company: { required: "Choose your favorite animal" },
      address: { required: "Choose your favorite animal" },
      buildingnumber: { required: "enter building name" },
      city: { required: "City is required" },
      stateorprovince: { required: "State is required" },
      country: { required: "Country is required" },
      companyid: { required: "CompanyID is required" },
      vatnumber: { required: "TAX Number is required" },
      sdi: { required: "SDI is required" },
      iban: { required: "IBAN is required" },
      postalcode: {
        required: "PostalCode is required",
        maxLength: "Max 8 characters",
      },
    },
  },
  data() {
    return {
      page: "BossAccount",
      //form: this.$store.state.userdata.user,
      countries: availableCountries,
      snackbar: false,     
      message:'',
      snackbar_color:'success', 
    };
  },
  computed: {
      ...mapGetters(["user"]),
  },
  methods: {
    resetForm() {
      this.form = Object.assign({}, defaultForm);
      this.$refs.form.reset();
      this.$v.$reset();
    },
    submit() {
      this.resetForm();
      this.$v.$reset();
    },
    save: _.debounce(function (event) {
        this.$parent.updateDB(event.target.name,event.target.value)
    }, 1000),
  },
  beforeDestroy() {
    this.form = null;
    delete this.form;
  },
};
</script>